import React from "react";

import Signal from "lib/icons/Signal";
import Chevron from "../../../../lib/icons/Chevron";
import { SupplierSelectCategory } from "./types";

import css from "./CategoryDropdown.module.scss";

type Props = {
  categories: SupplierSelectCategory[];
  handleCategorySelection: (category: SupplierSelectCategory) => void;
  getCategoryLabel: (category: SupplierSelectCategory) => string;
  showSignalIcon?: boolean;
};

function CategoryDropdown({
  categories,
  handleCategorySelection,
  getCategoryLabel,
  showSignalIcon = true,
}: Props) {
  return (
    <>
      {categories.map((category) => (
        <li
          key={category}
          className={css.option}
          onClick={(e) => {
            handleCategorySelection(category);
            e.stopPropagation();
          }}
        >
          <div className={css.optionlabel}>
            {showSignalIcon && (category === "Competitor" || category === "Partner") && (
              <Signal className={css.signalIcon} size={16} label="signalIcon" />
            )}
            <span>{getCategoryLabel(category)}</span>
          </div>
          <Chevron direction="right" />
        </li>
      ))}
    </>
  );
}

export default CategoryDropdown;
